import { useCallback, useContext, useEffect, useState } from "react";

import SocketContext from "../../../../context/SocketContext";

export default function Symbolpl({ standing, setPl, setColor }) {
  const socket = useContext(SocketContext);

  const { buy_sell, rate, qty, symbol_id, dollar_rate, type, rupee_dollar } =
    standing;

  const exchangeType =
    type === "comex_future" ||
    type === "crypto_future" ||
    type === "forex_future" ||
    type === "index" ||
    type === "us_stock" ||
    type === "dgcx";

  const [bid, setBid] = useState(0); // Renamed for clarity
  const [ask, setAsk] = useState(0); // Renamed for clarity
  const [profitLoss, setProfitLoss] = useState(0); // Renamed for clarity

  // Memoized P/L calculation logic
  const calculateProfitLoss = useCallback(
    (currentBid, currentAsk, currentLTP) => {
      let calculatedPrice = 0;
      let newProfitLoss = 0;

      if (buy_sell === 0) {
        // Buy position
        calculatedPrice = currentBid > 0 ? currentBid : currentLTP; // Prioritize Bid, fallback to LTP
        if (calculatedPrice > 0) {
          newProfitLoss =
            (parseFloat(calculatedPrice) - parseFloat(rate)) * parseFloat(qty);
        }
      } else if (buy_sell === 1) {
        // Sell position
        calculatedPrice = currentAsk > 0 ? currentAsk : currentLTP; // Prioritize Ask, fallback to LTP
        if (calculatedPrice > 0) {
          newProfitLoss =
            (parseFloat(rate) - parseFloat(calculatedPrice)) * parseFloat(qty);
        }
      }

      if (rupee_dollar === 0) {
        if (exchangeType) {
          newProfitLoss = parseFloat(newProfitLoss) * parseFloat(dollar_rate);
        }
      }
      setProfitLoss(newProfitLoss);
    },
    [buy_sell, type, rate, qty, rupee_dollar, dollar_rate],
  ); // Dependencies for calculation

  // Memoized socket trade handler
  const sockettrade = useCallback(
    (msg) => {
      if (msg != null) {
        // Only update state if values actually change to avoid unnecessary renders
        if (msg.Bid !== bid) {
          setBid(msg.Bid);
        }
        if (msg.Ask !== ask) {
          setAsk(msg.Ask);
        }
        // Always recalculate P/L with the latest msg values
        calculateProfitLoss(msg.Bid, msg.Ask, msg.LTP);
      }
    },
    [bid, ask, calculateProfitLoss],
  ); // Dependencies: bid, ask for comparison, calculateProfitLoss function

  useEffect(() => {
    if (!socket || !standing) return; // Ensure socket is available

    socket.emit("giverate", symbol_id);
    socket.on("trade" + symbol_id, sockettrade);

    return () => {
      socket.off("trade" + symbol_id, sockettrade);
    };
  }, [socket, standing, symbol_id, sockettrade]); // Dependencies for useEffect

  setPl(profitLoss);

  setColor(
    profitLoss > 0 ? "border-[var(--buymeta)]" : "border-[var(--sellmeta)]",
  );

  return null;
}
